var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8861 11.3472L8.78794 8.29846C9.59926 7.41698 10.0978 6.25122 10.0978 4.96841C10.0974 2.22426 7.83709 0 5.04869 0C2.26028 0 0 2.22426 0 4.96841C0 7.71257 2.26028 9.93683 5.04869 9.93683C6.25347 9.93683 7.35847 9.52011 8.22644 8.82731L11.3367 11.888C11.4882 12.0373 11.7342 12.0373 11.8858 11.888C12.0377 11.7388 12.0377 11.4964 11.8861 11.3472ZM5.04869 9.17241C2.68939 9.17241 0.776811 7.29022 0.776811 4.96841C0.776811 2.64661 2.68939 0.764419 5.04869 0.764419C7.408 0.764419 9.32056 2.64661 9.32056 4.96841C9.32056 7.29022 7.408 9.17241 5.04869 9.17241Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.a45aa293305e56b240a017500bd9b357.svg";
export { ForwardRef as ReactComponent };